import { ChainId } from '@plasma/plasmaswap-sdk';
import { createAction } from '@reduxjs/toolkit';
import { GasPrices, GasPriceSettings } from '../../types';

export const updateGsnTokenAddress = createAction<{ chainId: ChainId; address?: string }>('gasStation/updateGsnTokenAddress');
export const updateGasPriceSettings = createAction<{ chainId: ChainId; settings: Partial<GasPriceSettings> }>('gasStation/updateGasPriceSettings');
export const updateGasPrices = createAction<GasPrices>('gasStation/updateGasPrices');
